import {MenuItemsAggregate} from '../../aggregats/menu/menu-items.aggregate';
import {profilMenuItem} from './menu-items/top/profil/menu-item.constantes';
import {aideMenuItem} from './menu-items/top/aide/menu-item.constantes';
import {tachesMenuItem} from './menu-items/top/taches/menu-item.constantes';
import {agendaTachesMenuItem} from './menu-items/top/agenda-taches/menu-item.constantes';

export const menuTop: MenuItemsAggregate = new MenuItemsAggregate([agendaTachesMenuItem, tachesMenuItem, aideMenuItem, profilMenuItem]);
